import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../resources/services/auth.service';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {

  date: Date = new Date();

  stream: Subscription;

  constructor(private _authService: AuthService) { }

  ngOnInit(): void {
  }
}
